import Message from './components/Message/Message';
import { useBroadcast } from './hooks/useBroadcast';
import { useGetParams } from './hooks/useGetParams';
import defaultBackground from './assets/images/bg.png';

import { useEffect, useMemo, useState } from 'react';
import { AnimatePresence, motion } from 'motion/react';

function App() {
  const { currentState, isVisible, currentMessage, setDelay } = useBroadcast();
  const { bg, bgColor } = useGetParams();

  const [isFirst, setIsFirst] = useState(true);

  useEffect(() => {
    if (isFirst && currentState === 'S1') {
      setIsFirst(false);
    } else if (!isFirst && currentState !== 'S1') {
      setIsFirst(true);
    }
  }, [currentState, isFirst]);

  const background = useMemo(() => {
    return bg && bg !== '0'
      ? `url(${
          bg === '1' ? defaultBackground : bg
        }) center/cover no-repeat, ${bgColor}`
      : `none, ${bgColor}`;
  }, [bg, bgColor]);

  return (
    <div className="app-wrapper" style={{ background }}>
      <AnimatePresence mode="wait">
        {currentState === 'S1' && (
          <motion.div
            key={`msg-${currentState}`}
            style={{ width: '100%' }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4 }}
          >
            <Message
              message={currentMessage?.message || {}}
              isFirst={isFirst}
              setDelay={setDelay}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;
